/**
 * Bundle Box — Currency Converter
 * Scoped to: /products/4l-cw45
 *
 * Converts ONLY:
 *   - .bundle-box__price-old on the 4 gift items (items 2,3,4,5)
 *   - .bundle-box__original-price (total compare_at: $223.95)
 *
 * Leaves untouched:
 *   - Main product prices (item 1) — Shopify already handles those
 *   - All FREE values
 *   - .bundle-box__total-price — Shopify already handles that
 */

(function () {
  'use strict';

  if (!window.location.pathname.includes('/products/4l-cw45')) return;

  function parseUSDFloat(text) {
    const trimmed = (text || '').trim();
    if (/^free$/i.test(trimmed)) return null;
    const numeric = trimmed.replace(/[^0-9.]/g, '');
    if (!numeric) return null;
    const val = parseFloat(numeric);
    return isNaN(val) ? null : val;
  }

  function formatCurrency(amount, code) {
    try {
      return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (_) {
      return code + '\u00a0' + amount.toFixed(2);
    }
  }

  function getMarketCurrency() {
    return new Promise((resolve) => {
      const sc = window.Shopify?.currency;
      if (sc?.active && sc?.rate) {
        resolve({ active: sc.active, rate: parseFloat(sc.rate) });
        return;
      }
      fetch('/cart.js')
        .then((r) => r.json())
        .then((c) => resolve({ active: c.currency || 'USD', rate: 1 }))
        .catch(() => resolve({ active: 'USD', rate: 1 }));
    });
  }

  async function run() {
    const bundleBox = document.querySelector('.bundle-box');
    if (!bundleBox) return;

    const { active, rate } = await getMarketCurrency();

    // ── 1. Gift items: items 2,3,4,5 (index 1–4) → convert price-old only ──
    const allItems = bundleBox.querySelectorAll('.bundle-box__item');

    allItems.forEach((item, index) => {
      // Skip first item (main product — Shopify handles it)
      if (index === 0) return;

      const priceOld = item.querySelector('.bundle-box__price-old');
      if (!priceOld) return;
      if (priceOld.dataset.currencyDone === active) return;

      // Store original USD once
      if (!priceOld.dataset.usd) {
        const usd = parseUSDFloat(priceOld.textContent);
        if (usd === null) return;
        priceOld.dataset.usd = usd.toString();
      }

      const converted = parseFloat(priceOld.dataset.usd) * rate;
      priceOld.textContent = formatCurrency(converted, active);
      priceOld.dataset.currencyDone = active;
    });

    // ── 2. Total compare_at ($223.95) ─────────────────────────────────────
    const originalPrice = bundleBox.querySelector('.bundle-box__original-price');
    if (originalPrice && originalPrice.dataset.currencyDone !== active) {
      if (!originalPrice.dataset.usd) {
        const usd = parseUSDFloat(originalPrice.textContent);
        if (usd !== null) originalPrice.dataset.usd = usd.toString();
      }
      if (originalPrice.dataset.usd) {
        const converted = parseFloat(originalPrice.dataset.usd) * rate;
        originalPrice.textContent = formatCurrency(converted, active);
        originalPrice.dataset.currencyDone = active;
      }
    }
  }

  // ── Currency switcher support ─────────────────────────────────────────────
  function resetAndRun() {
    document.querySelectorAll('.bundle-box [data-currency-done]').forEach((el) => {
      delete el.dataset.currencyDone;
    });
    run();
  }

  document.addEventListener('currency:changed', resetAndRun);

  let _last = window.Shopify?.currency?.active;
  setInterval(() => {
    const cur = window.Shopify?.currency?.active;
    if (cur && cur !== _last) { _last = cur; resetAndRun(); }
  }, 800);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();